export default __webpack_public_path__ + "static/media/euchre.8fce5f31.svg";